function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.078a6.922 6.922 0 100 13.844A6.922 6.922 0 008 1.078zM0 8a8 8 0 1116 0A8 8 0 010 8zm8-3.606c-1.298 0-2.298.623-2.64 1.349a.539.539 0 11-.975-.46C4.953 4.077 6.411 3.316 8 3.316c1.021 0 1.966.31 2.668.836.702.527 1.187 1.296 1.187 2.19 0 1.521-1.359 2.638-2.93 2.939-.258.05-.386.237-.386.377a.539.539 0 11-1.078 0c0-.776.621-1.313 1.262-1.436 1.295-.248 2.054-1.08 2.054-1.88 0-.48-.257-.954-.755-1.328-.499-.373-1.212-.62-2.022-.62z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.666 12c0 .359-.295.65-.66.65h-.01a.655.655 0 01-.66-.65c0-.359.295-.65.66-.65h.01c.365 0 .66.291.66.65z"
}));
function SvgCirculoconinterrogacion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Circulo con interrogacion.svg";
export { SvgCirculoconinterrogacion as ReactComponent };